/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-06-07 11:05:30
 *
 *******************************************************/
// @flow

import React from 'react';
import { Icon, Link } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { LockMinor, ExternalSmallMinor } from '@shopify/polaris-icons';
import { URL } from 'src/constants/links';
import history from 'src/routes/history';
import { routes } from 'src/routes';
import LockImage from 'src/assets/images/lock-unlock-image/search-merchandising-lock.svg';
import rocketIcon from 'assets/images/common/rocket-icon.png';

const LockCard = props => {
  const { i18n } = props;

  return (
    <div className="pfs-freemium-card-lock">
      <div className="video-row row">
        <div className="content">
          <div className="heading">
            <img src={rocketIcon} alt="pfs-rocket-icon" width={24} height={24} />

            {i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Heading01')}
          </div>
          <p>{i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Content01')}</p>
          <div className="action">
            <div
              className={`Polaris-Button`}
              onClick={() => history.push(routes.subscription.package())}>
              <Icon source={LockMinor} />
              {i18n.translate(`AdminHTML.Common.Action.upgradeToUnlock`)}
            </div>
            <Link external url={URL['Link_V2_Merchandising_MerchandisingV2_ManualGuide']}>
              {i18n.translate('AdminHTML.Common.Action.learnMore')}
              <Icon source={ExternalSmallMinor} color={'interactive'}></Icon>
            </Link>
          </div>
        </div>
        <div className="media">
          <iframe
            src={URL['MerchandisingTut']}
            title={'Merge values'}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
      <div className="image-row row">
        <div className="media">
          <img src={LockImage} alt="search-merchandising-lock" />
        </div>
        <div className="content">
          <div className="heading">
            <img src={rocketIcon} alt="pfs-rocket-icon" width={24} height={24} />
            {i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Heading02')}
          </div>
          <ul>
            <li>{i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Content02_Line01')}</li>
            <li>{i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Content02_Line02')}</li>
            <li>{i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Content02_Line03')}</li>
            <li>{i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Content02_Line04')}</li>
            <li>{i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Content02_Line05')}</li>
            <li>{i18n.translate('AdminHTML.MerchandisingV2.Plan.card_Content02_Line06')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default withI18n()(LockCard);
